"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/patientResponse/ClinicHelp.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactdom = require('react-dom');

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _ClinicContactCard = require('web/components/ClinicBranding/ClinicContactCard'); var _ClinicContactCard2 = _interopRequireDefault(_ClinicContactCard);

var _MessageActions = require('./MessageActions');


/* The ? of a clinic that turned its contact card on (D-11, D-13): it opens
 * the card in a sheet over the chat on a phone, or a popover under the ?
 * with a mouse, as the message actions do. Escape, the scrim, a press
 * outside the popover or Close shut it, and focus returns to the ?. */

const POPOVER_GAP_PX = 8
const VIEWPORT_MARGIN_PX = 8








const ClinicContactPanel = ({ clinic, variant, anchor, onClose }) => {
  const panelRef = _react.useRef(null)
  const headingId = _react.useId.call(void 0, )
  const [position, setPosition] = _react.useState(undefined)

  // The popover opens under the ?, its right edge on the ?'s, inside the window.
  _react.useLayoutEffect.call(void 0, () => {
    if (variant !== 'popover' || !panelRef.current) return
    const from = anchor.getBoundingClientRect()
    const panel = panelRef.current.getBoundingClientRect()
    const left = Math.min(
      Math.max(VIEWPORT_MARGIN_PX, from.right - panel.width),
      window.innerWidth - VIEWPORT_MARGIN_PX - panel.width,
    )
    setPosition({ top: from.bottom + POPOVER_GAP_PX, left })
  }, [variant, anchor])

  _react.useEffect.call(void 0, () => {
    const panel = panelRef.current
    _optionalChain([panel, 'optionalAccess', _ => _.querySelector, 'call', _2 => _2('.clinic-card--close'), 'optionalAccess', _3 => _3.focus, 'call', _4 => _4()])
    return () => {
      const focused = document.activeElement
      if (!focused || focused === document.body || _optionalChain([panel, 'optionalAccess', _5 => _5.contains, 'call', _6 => _6(focused)])) anchor.focus()
    }
  }, [anchor])

  const close = _react.useEffectEvent.call(void 0, () => onClose())
  _react.useEffect.call(void 0, () => {
    const onKey = (event) => { if (event.key === 'Escape') close() }
    const onPointer = (event) => {
      const target = event.target 
      if (variant === 'popover' && !_optionalChain([panelRef, 'access', _7 => _7.current, 'optionalAccess', _8 => _8.contains, 'call', _9 => _9(target)]) && !anchor.contains(target)) close()
    }
    document.addEventListener('keydown', onKey)
    document.addEventListener('pointerdown', onPointer)
    return () => {
      document.removeEventListener('keydown', onKey)
      document.removeEventListener('pointerdown', onPointer)
    }
  }, [variant, anchor])

  const target = _nullishCoalesce(anchor.closest('.patient-page--card'), () => ( anchor.ownerDocument.body))
  const panel = (
    _react2.default.createElement('div', {
      ref: panelRef,
      className: _classBuilder2.default.call(void 0, 'clinic-contact', `clinic-contact--${variant}`),
      role: "dialog",
      'aria-labelledby': headingId,
      // Until it is placed it is drawn transparent, not hidden, so focus can move into it.
      style: variant === 'popover' ? _nullishCoalesce(position, () => ( { opacity: 0, pointerEvents: 'none' })) : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}

      ,  variant === 'sheet' && _react2.default.createElement('div', { className: "message-actions--grab", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}} ) 
      , _react2.default.createElement(_ClinicContactCard2.default, { clinic: clinic, headingId: headingId, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}} )
    )
  )

  return _reactdom.createPortal.call(void 0, 
    variant === 'sheet'
      ? (
          _react2.default.createElement('div', { className: "message-actions--layer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
            , _react2.default.createElement('div', { className: "message-actions--scrim", onClick: onClose, 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}} )
            ,  panel 
          )
        )
      : panel,
    target,
  )
}






const ClinicHelp = ({ clinic, children }) => {
  const buttonRef = _react.useRef(null)
  const [variant, setVariant] = _react.useState(null)
  const open = _react.useCallback.call(void 0, () => setVariant(v => v ? null : _MessageActions.actionsVariant.call(void 0, )), [])
  const close = _react.useCallback.call(void 0, () => setVariant(null), [])

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('button', {
        ref: buttonRef,
        type: "button",
        className: "patient-page--inline-help",
        'aria-label': `Contact ${clinic.Name || 'the clinic'}`,
        'aria-haspopup': "dialog",
        'aria-expanded': variant !== null,
        onClick: open, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}

        ,  children 
      )
      ,  variant && buttonRef.current && (
        _react2.default.createElement(ClinicContactPanel, { clinic: clinic, variant: variant, anchor: buttonRef.current, onClose: close, __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}} )
      )
    )
  )
}

exports. default = ClinicHelp
